import { useCallback, useEffect, useState } from 'react';

export const STATE_COLORS = {
  draft: 'bg-stone-100 text-stone-600',
  in_review: 'bg-amber-100 text-amber-700',
  published: 'bg-emerald-100 text-emerald-700',
  deprecated: 'bg-red-100 text-red-700',
};

export const STATE_LABELS = {
  draft: 'Brouillon',
  in_review: 'En relecture',
  published: 'Validé',
  deprecated: 'Obsolète',
};

export function formatRevisionDate(isoStr) {
  if (!isoStr) return '';
  const d = new Date(isoStr);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Hook to fetch and manage doc page revisions.
 * Listens to `doc:page-saved` for live refresh.
 */
export function useDocRevisions(pageId) {
  const [revisions, setRevisions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadRevisions = useCallback(async () => {
    if (!pageId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/doc/revisions/${pageId}`, {
        credentials: 'include',
      });
      if (!res.ok) {
        if (res.status === 404) {
          setError('Historique non disponible.');
          setRevisions([]);
          return;
        }
        throw new Error(`${res.status}`);
      }
      const data = await res.json();
      setRevisions(Array.isArray(data) ? data : []);
    } catch (err) {
      setError('Impossible de charger les révisions.');
      console.error('[useDocRevisions] load error:', err);
    } finally {
      setLoading(false);
    }
  }, [pageId]);

  useEffect(() => {
    loadRevisions();
  }, [loadRevisions]);

  useEffect(() => {
    const handler = () => loadRevisions();
    window.addEventListener('doc:page-saved', handler);
    return () => window.removeEventListener('doc:page-saved', handler);
  }, [loadRevisions]);

  return { revisions, loading, error, reload: loadRevisions };
}
